import React, { useRef, useState } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { JoinWaitlist } from "../../utils/api/JoinWaitlist";
import { FaRegCheckCircle } from "react-icons/fa";

const Footer = () => {
  const form = useRef();
  const [waitlisted, setWaitlisted] = useState(false);
  const waitlist = async (e) => {
    console.log(form.current.phoneNumber.value);

    e.preventDefault();
    const joinWaitlist = await JoinWaitlist(form.current.phoneNumber.value);
    // console.log(joinWaitlist);
    setWaitlisted(true);
    form.current.reset();
  };
  return (
    <div className="flex lg:gap-16 gap-8 flex-col lg:p-16 px-6 py-12  bg-[#131D2D] lg:items-center mt-14 rounded-t-[52px] lg:h-[640px] h-[579px] relative">
      <div className="flex flex-col lg:gap-14 gap-10 lg:w-[522px] w-[320px] lg:text-4xl text-[20px] font-semibold  text-white  lg:text-center text-left">
        <h3 className="leading-[140%] lg:text-center">
          <span className="inline">India’s First</span>{" "}
          <span className="text-[#FF2D5A] inline">Zero Commission</span>{" "}
          <span className="block lg:inline">Hyperlocal Delivery</span>
        </h3>
        <div className="w-[345px] lg:w-auto flex lg:gap-6 gap-4 lg:items-center lg:justify-center">
          {/* <span className="flex justify-center items-center">
            <img src="/Images/assets/googleplay.svg" alt="" />
          </span>
          <span>
            <img src="/Images/assets/appstore.svg" alt="" />
          </span> */}
          <form
            className="lg:w-[418px] w-[278px] flex  lg:items-center text-[#94A0B3]"
            ref={form}
            onSubmit={waitlist}
          >
            <input
              name="phoneNumber"
              type="tel"
              inputMode="numeric"
              pattern="[0-9]*"
              className="lg:border bg-opacity-20 z-10  bg-white z border-[0.67px] lg:p-5 p-4 border-[#E5204B] rounded-xl lg:w-[301px] w-[200px] lg:h-[60px] h-10  focus:outline-none lg:text-base text-[10px] placeholder-[#94A0B3]"
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              placeholder="Enter Phone Number"
            />
            <button
              type="submit"
              disabled={waitlisted}
              className={`bg-[#E5204B] ${
                waitlisted ? "lg:-ml-20 -ml-16" : "lg:-ml-10 -ml-8"
              } px-5 lg:h-[60px]  h-10 justify-center items-center z-20 flex rounded-xl text-[#F7F9FA] lg:text-lg text-xs font-semibold`}
            >
              {waitlisted ? (
                <div className="flex gap-1 justify-center items-center">
                  <FaRegCheckCircle /> We’ll notify you
                </div>
              ) : (
                "Join Waitlist"
              )}
            </button>
          </form>
        </div>
      </div>

      <div className="w-[75px] h-[24px] lg:hidden flex justify-center items-center">
        <img src="/Images/Logo.svg" alt="" />
      </div>

      <div className="lg:w-[1297px] w-[343px] flex lg:flex-row flex-col-reverse lg:justify-between lg:gap-3 gap-16 gap justify-start lg:items-center text-white lg:text-base text-xs font-medium opacity-35">
        <h4>© 2025 Flit - All rights reserved</h4>
        <ul className="flex gap-4 lg:items-center lg:text-base text-xs font-medium lg:flex-row flex-col">
          <Link to="/privacy/#privacy">
            <li>Privacy Policy</li>
          </Link>
          <Link to="/refund/#refund">
            <li>Refund & Cancellation Policy</li>
          </Link>
          <Link to="/terms/user/#terms">
            <li>Terms of Use</li>
          </Link>
          <Link to="/terms/partner/#terms-partners">
            <li>Terms of Use (Delivery Partners)</li>
          </Link>
        </ul>
      </div>

      <div className="w-[340px] lg:w-full opacity-10 border border-[#DDE3ED] bg-[#DDE3ED]  absolute lg:bottom-60 bottom-40  "></div>

      <div className="absolute bottom-0 lg:w-auto w-[376px] left-0">
        <img src="/Images/assets/BigLogo.svg" alt="" />
      </div>
    </div>
  );
};

export default Footer;
